// extracted by mini-css-extract-plugin
export default {"container":"panel_container__LZNtG","header":"panel_header__QyJSV","title":"panel_title__xk7Gm","titleTooltip":"panel_titleTooltip__hZqyu"};